import { useTranslation } from 'react-i18next';
import { NumberBadge, NumberBadgeItems } from '../../../components/common/NumberBadge';

export default function LibrarySideList({ libCategory, selectedCategory, selectedBookId, setSelectedCategory, setSelectedBookId, setCurrentPage, itemCount, handleChange }) {
    const { t, i18n } = useTranslation();

    // Add check for libCategory
    if (!Array.isArray(libCategory)) {
        return null; // or return a loading state
    }

    return (
        <>
            <select className="form-select form-select-sm d-md-none" value={selectedCategory}
                onChange={handleChange}>
                <option value="">{t("AllBooks")}</option>
                {libCategory.map(category =>
                    <option key={category.id} value={category.name} >
                        {i18n.language === "ar" ? category.nameAr : category.name}
                    </option>
                )}
            </select>
            <ul className={`d-none d-md-block list-group col-6 ${selectedBookId ? "col-md-12 mb-3 text-center" : "col-md-3"} pt-2 h-100 px-2`}>
                {selectedBookId ?
                    <li className={`list-group-item list-group-item-action ps-2 bg-light-gray`}
                        onClick={() => {
                            setSelectedCategory(null);
                            setSelectedBookId(null);
                        }}>
                        {t("AllBooks")}
                    </li>
                    :
                    <>
                        <li className={`list-group-item list-group-item-action ps-2 bg-light-gray`}
                            onClick={() => {
                                setSelectedCategory(null);
                                setSelectedBookId(null);
                            }}>
                            {t("AllBooks")}
                            <NumberBadge
                                selectedCategory={selectedCategory}
                                itemCount={itemCount}
                            />
                        </li>
                        {libCategory
                            .sort((a, b) => a.id - b.id)
                            .map(category =>
                                <li key={category.id} className={`list-group-item list-group-item-action ps-2 ${selectedCategory === category.id ? 'active' : ''}`}
                                    onClick={() => {
                                        setSelectedCategory(category.id);
                                        setCurrentPage(1);
                                    }}>
                                    {i18n.language === "ar" ? category.nameAr : category.name}
                                    <NumberBadgeItems
                                        selectedCategory={selectedCategory}
                                        itemCount={itemCount}
                                        category={category.id}
                                    />
                                </li>
                            )}
                    </>}
            </ul>
        </>
    )
}